import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../hooks/useAuth";

type PlanTier = "libre" | "plus" | "pro" | "max";
const PLAN_BADGE: Record<PlanTier, { label: string; bg: string; color: string }> = {
  libre: { label: "Libre", bg: "#E9F0E6", color: "#2F5742" },
  plus:  { label: "Plus",  bg: "#C49A8A", color: "#fff" },
  pro:   { label: "Pro",   bg: "#2D2D2D", color: "#fff" },
  max:   { label: "Max ✦", bg: "#D4B464", color: "#1A1208" },
};

export default function PagoExitoso() {
  const { token } = useAuth();
  const [planTier, setPlanTier] = useState<PlanTier | null>(null);

  useEffect(() => {
    if (!token) return;
    api.getSubscripcion(token).then((r) => {
      if (r.ok) setPlanTier(r.data.plan_tier);
    }).catch(() => {});
  }, [token]);

  return (
    <div style={{
      minHeight: "100vh", display: "grid", placeItems: "center", background: "var(--bg)",
      fontFamily: "var(--font-body)", padding: 24,
    }}>
      <div className="card" style={{ maxWidth: 440, width: "100%", padding: 40, textAlign: "center" }}>
        <img src="/logo-psicodosis.png" alt="PzicoDosis" style={{ width: 40, height: 40, objectFit: "contain", marginBottom: 18 }} />

        <div style={{
          width: 64, height: 64, borderRadius: "50%", background: "var(--sage)",
          display: "grid", placeItems: "center", margin: "0 auto 20px",
        }}>
          <svg width="30" height="30" viewBox="0 0 24 24" fill="none">
            <path d="M5 13l4 4L19 7" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>

        <h1 style={{ fontFamily: "var(--font-display)", fontWeight: 800, fontSize: 26, letterSpacing: "-0.02em", margin: "0 0 6px" }}>
          ¡Pago exitoso! 🎉
        </h1>
        <p style={{ fontSize: 14.5, color: "var(--muted)", margin: "0 0 22px" }}>
          Tu membresía está activa
        </p>

        {planTier && (
          <div style={{
            background: "var(--sage-soft)", border: "1px solid var(--sage-light)", borderRadius: 14,
            padding: "16px 20px", marginBottom: 20, display: "flex", alignItems: "center", justifyContent: "center", gap: 10,
          }}>
            <span className="badge" style={{ background: PLAN_BADGE[planTier].bg, color: PLAN_BADGE[planTier].color }}>
              Plan {PLAN_BADGE[planTier].label}
            </span>
          </div>
        )}

        <p style={{ fontSize: 14, color: "var(--muted)", lineHeight: 1.6, margin: "0 0 28px" }}>
          Ya tienes acceso a todos los beneficios de tu plan.
        </p>

        <Link to="/dashboard" className="btn btn-primary btn--full" style={{ textDecoration: "none", marginBottom: 12 }}>
          Ir a mi espacio
        </Link>
        <Link to="/biblioteca" className="btn btn-outline btn--full" style={{ textDecoration: "none" }}>
          Ver mis beneficios
        </Link>
      </div>
    </div>
  );
}
